import React from "react";
import { TrialBalanceResponse } from "../../../common/contracts/accounting-reports";
import { TrialBalanceTableRow } from "./TrialBalanceTableRow";

interface Props {
    data: TrialBalanceResponse;
}

export const TrialBalanceTableBody: React.FC<Props> = ({ data }) => {
    const { rows, periods } = data;

    return (
        <tbody>
            {rows.map((row, index) => (
                <TrialBalanceTableRow
                    row={row}
                    periods={periods}
                    isSummary={index === rows.length - 1}
                    key={row.key}
                />
            ))}
        </tbody>
    );
};
